var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRelay1Off(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00001 14.25C9.41401 14.25 9.75001 14.586 9.75001 15C9.75001 15.414 9.41401 15.75 9.00001 15.75C8.586 15.75 8.25 15.414 8.25 15C8.25 14.586 8.586 14.25 9.00001 14.25Z",
    fill: "#23D4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.54221 8.56863L10.3865 3.24571C10.4197 3.19985 10.4915 3.23562 10.4749 3.28969L9.39313 6.80532C9.33377 6.99824 9.47802 7.19355 9.67987 7.19355H11.2384C11.3607 7.19355 11.4316 7.33217 11.36 7.43137L7.4831 12.7994C7.45116 12.8436 7.38158 12.812 7.39385 12.7588L8.22114 9.17391C8.26452 8.98592 8.12175 8.80645 7.92882 8.80645H6.66382C6.54145 8.80645 6.47057 8.66782 6.54221 8.56863Z",
    fill: "#23D4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelay1Off);
export default __webpack_public_path__ + "static/media/relay-1-off.2adb9fc82312aa3e4b7fa1a262badbe2.svg";
export { ForwardRef as ReactComponent };